var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00533 1.6665V4.1665M14.0106 1.6665V4.1665M3.06485 7.57484H17.9511M18.3889 7.08317V14.1665C18.3889 16.6665 17.0755 18.3332 14.0106 18.3332H7.00533C3.94051 18.3332 2.62701 16.6665 2.62701 14.1665V7.08317C2.62701 4.58317 3.94051 2.9165 7.00533 2.9165H14.0106C17.0755 2.9165 18.3889 4.58317 18.3889 7.08317Z",
    stroke: "#84949F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7435 11.4165H13.7514M13.7435 13.9165H13.7514M10.5036 11.4165H10.5123M10.5036 13.9165H10.5123M7.26276 11.4165H7.27151M7.26276 13.9165H7.27151",
    stroke: "#84949F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.97187d67a852f9d783cbbf52235b097f.svg";
export { ForwardRef as ReactComponent };